/**
 * Dialogs: the Розмови screen (ADR-0007) — every conversation with an assistant, where it runs, when
 * it last moved and whether it waits for the human.
 */
export const dialogs = {
  'nav.dialogs': 'Розмови',
  'dialogs.title': 'Розмови',
  'dialogs.intro': 'Кожна розмова з Claude: де вона, коли рухалась і чи чекає на вас. Записують хуки плагіна «Офіс» у Claude Code і планова задача для claude.ai.',
  'dialogs.empty': 'Розмов ще немає. Вони з’являться самі, щойно почнеться розмова в Claude Code з плагіном «Офіс».',
  'dialogs.notFound': 'Розмову не знайдено',
  'dialogs.shown': 'Показано {shown} з {total} · сторінка {page}',
  'dialogs.page.prev': 'Назад',
  'dialogs.page.next': 'Далі',
  'dialogs.filter.allBusinesses': 'Усі бізнеси',
  'dialogs.filter.allTools': 'Усі інструменти',
  'dialogs.chip.all': 'Усі',
  'dialogs.status.working': 'Працює',
  'dialogs.status.waiting_human': 'Чекає на вас',
  'dialogs.status.stale': 'Зависла',
  'dialogs.status.done': 'Завершена',
  'dialogs.tool.claude_code': 'Claude Code',
  'dialogs.tool.cowork': 'Cowork',
  'dialogs.tool.claude_ai': 'claude.ai',
  'dialogs.col.title': 'Розмова',
  'dialogs.col.tool': 'Інструмент',
  'dialogs.col.business': 'Бізнес',
  'dialogs.col.status': 'Стан',
  'dialogs.col.lastActivity': 'Останній рух',
  'dialogs.col.questions': 'Питання',
  'dialogs.detail.close': 'Закрити',
  'dialogs.detail.started': 'почалась {when}',
  'dialogs.detail.lastActivity': 'останній рух {when}',
  'dialogs.detail.folder': 'Папка: {folder}',
  'dialogs.detail.lastMessage': 'Остання відповідь',
  'dialogs.detail.tasks': 'Задачі з цієї розмови',
  'dialogs.detail.noTasks': 'Задач із цієї розмови немає.',
  'dialogs.detail.open': 'Відкрити розмову',
  'dialogs.detail.resume': 'Продовжити в терміналі: {command}',
  'dialogs.noBusiness': '—',
} as const;
